import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  justify-content: space-between;
`;

export const SelectBasesWrap = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

export const BasesContainer = styled.div`
  max-height: 500px;
  overflow-y: auto;
  padding: 0 8px 0 0;
  gap: 12px;
  display: flex;
  flex-direction: column;

  &::-webkit-scrollbar {
    width: 12px;
  }

  &::-webkit-scrollbar-track {
    background: #e9e9e9;
    border-radius: 6px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #0b29fb;
    border-radius: 6px;
    border: 2px solid #e9e9e9;
  }

  &::-webkit-scrollbar-thumb:hover {
    background-color: #0b29fb;
    border-radius: 6px;
  }
`;

export const ResposibleDataForm = styled.div`
  width: 68%;
  padding: 0 16px;

  @media (max-width: 768px) {
    width: 100%;
  }
`;

export const ContainerForm = styled.div`
  margin-top: 24px;
  display: flex;
  flex-direction: column;
  width: 100%;
`;

export const Label = styled.label`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

export const ResposibleFormHeader = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const ResponsibleDataTitle = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;

export const ResponsibleDataSubTitle = styled.span`
  display: inline-flex;
  font-family: 'Mangueira';
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #3d3d3d;

  @media (max-width: 768px) {
    font-size: 12px;
    line-height: 18px;
  }
`;
